import get from 'lodash/get';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Field } from 'redux-form';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import { getBartendingQuote } from '../../catering-utils';

export const CateringAddOnBartendingField = ({
  numberOfGuests,
  addOn,
  formValues
}) => {
  const { bartendingTotal, rate } = getBartendingQuote(numberOfGuests, addOn);
  const isSelected = get(formValues, `addOns.${addOn.id}`, false);

  return (
    <div className="catering-form-checkbox-wrap">
      <Field
        name={`addOns.${addOn.id}`}
        component={CheckboxField}
        id={addOn.id}
        attributes={{
          checked: isSelected
        }}
        label={
          <span>
            Add bartending package for{' '}
            <FormattedNumber
              value={bartendingTotal || 0}
              currency="USD"
              style="currency"
              maximumFractionDigits={0}
            />{' '}
            <span className="text-gray-600">
              ({numberOfGuests} guests,{' '}
              <FormattedNumber
                value={rate || 0}
                currency="USD"
                style="currency"
                maximumFractionDigits={0}
              />{' '}
              per guest)
            </span>
          </span>
        }
        value={addOn.id}
        option={addOn.id}
      />
    </div>
  );
};
